import { INVOICE_FONTS } from "@/pages/preview/palettes";

export default function InvoiceFonts() {
  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="invoice-fonts-gallery">
      {INVOICE_FONTS.map((f, i) => (
        <div key={f.id} className="bg-white rounded-2xl shadow p-3" data-testid={`invoice-font-${f.id}`}>
          <div className="flex items-center justify-between mb-2 px-1">
            <b className="text-lg">الخط {i + 1}: {f.name}</b>
            <span className="text-xs text-slate-500">{f.note}</span>
          </div>
          <a href={`/img/invoice-fonts/${f.id}.png`} target="_blank" rel="noreferrer">
            <img src={`/img/invoice-fonts/${f.id}.png`} alt={`فاتورة بخط ${f.name}`} className="w-full rounded-xl border" loading="lazy" />
          </a>
        </div>
      ))}
    </div>
  );
}
